import _ from 'lodash'

export default ({ type, dices: { end } }) => (data) => {
  if (!_.includes(['move', 'duel'], type)) return

  return end(data.respond.dices)
}
